import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /**  A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.  */
  DateTime: { input: any; output: any; }
  /**  The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).  */
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  ObjMap: { input: any; output: any; }
  /**  A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt.  */
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** Represents empty values */
  Void: { input: any; output: any; }
};

/** Return type indicating an error state when there is no active game for member. */
export type ActiveGameNotFound = ErrorMessage & {
  __typename?: 'ActiveGameNotFound';
  /** Error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Return type indicating an error state when there is no active program for member. */
export type ActiveProgramNotFound = ErrorMessage & {
  __typename?: 'ActiveProgramNotFound';
  /** Error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Measurement data of activity input */
export type ActivityMeasurement = {
  /** Source App if known */
  app?: InputMaybe<Scalars['String']['input']>;
  /** Source Device if known */
  device?: InputMaybe<Scalars['String']['input']>;
  measurementType: ActivityMeasurementType;
  /** Timestamp of measurement. E.g.: 1996-12-19T16:39:57-08:00 or 1996-12-19T16:39:57Z */
  timestamp: Scalars['DateTime']['input'];
  unit: MeasurementUnit;
  /** Is the measurement from a validated source? */
  validated: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

/** Type of activity measurement */
export enum ActivityMeasurementType {
  /** Cumulative Active Minutes measurement. Units: MILLISECOND */
  CumulativeActiveMinutes = 'CUMULATIVE_ACTIVE_MINUTES',
  /** Cumulative Calories(kcal) measured. Units: KILOCALORIE */
  CumulativeCaloriesBurned = 'CUMULATIVE_CALORIES_BURNED',
  /** Cumulative Distance measurement. Units: KILOMETER | METER */
  CumulativeDistance = 'CUMULATIVE_DISTANCE',
  /** Cumulative steps measured. Units: COUNT */
  CumulativeSteps = 'CUMULATIVE_STEPS'
}

/** Supported providers */
export enum ActivityProvider {
  AppleHealth = 'APPLE_HEALTH',
  GoogleFit = 'GOOGLE_FIT',
  Shealth = 'SHEALTH'
}

/** Supported vendors */
export enum ActivityVendor {
  AppleHealth = 'APPLE_HEALTH',
  GoogleFit = 'GOOGLE_FIT',
  Shealth = 'SHEALTH'
}

export type BenefitPagesSponsorSettings = {
  __typename?: 'BenefitPagesSponsorSettings';
  benefitsPagesSetting?: Maybe<BenefitsPagesSetting>;
  benefitsSponsorSetting: BenefitSponsorSetting;
  isNavigateExperience: Scalars['Boolean']['output'];
  isTpaEnabled: Scalars['Boolean']['output'];
  sponsorSettings: SponsorSettingsBenefits;
  sponsorSettingsUi: SponsorSettingsUiBenefits;
  tpaSponsorSetting: TpaSponsorSettings;
};

export type BenefitSponsorSetting = {
  __typename?: 'BenefitSponsorSetting';
  customLogoUrl?: Maybe<Scalars['String']['output']>;
  shouldDisplayRecommended: Scalars['Boolean']['output'];
  shouldOverwriteBenefitsText: Scalars['Boolean']['output'];
  vpNavigateOption?: Maybe<Scalars['String']['output']>;
};

export type BenefitsPageLayout = {
  __typename?: 'BenefitsPageLayout';
  pageTitle: Scalars['String']['output'];
};

export type BenefitsPagesSetting = {
  __typename?: 'BenefitsPagesSetting';
  benefitsPage?: Maybe<BenefitsPageLayout>;
  programsPage?: Maybe<BenefitsPageLayout>;
};

/** Details of a care gap. */
export type CareGapDetails = {
  __typename?: 'CareGapDetails';
  /** Date of compliance for the care gap. */
  complianceDate?: Maybe<Scalars['String']['output']>;
  /** End date for the care gap's effectiveness. */
  effectiveEndDate?: Maybe<Scalars['String']['output']>;
  /** Start date for the care gap's effectiveness. */
  effectiveStartDate?: Maybe<Scalars['String']['output']>;
  /** Name of the care gap. */
  gapName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the care gap. */
  id: Scalars['ID']['output'];
};

/** Connection type for preventive care gaps. */
export type CareGapDetailsConnection = {
  __typename?: 'CareGapDetailsConnection';
  /** List of preventive care gap edges. */
  edges: Array<CareGapDetailsEdge>;
  /** Pagination information for the connection. */
  pageInfo: PageInfo;
};

/** Edge type for preventive care gaps. */
export type CareGapDetailsEdge = {
  __typename?: 'CareGapDetailsEdge';
  /** Cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** Preventive care gap data. */
  node: CareGapDetails;
};

/** Result of a preventive care gaps query, either a connection or an error. */
export type CareGapDetailsResult = CareGapDetailsConnection | InvalidPaginationParameter;

/** Care gaps data for a person, including health situations and preventive care gaps. */
export type CareGaps = {
  __typename?: 'CareGaps';
  /** Retrieves health situation care gaps with pagination. */
  healthSituation: HealthSituationResult;
  /** Retrieves preventive care gaps with pagination. */
  preventive: CareGapDetailsResult;
};


/** Care gaps data for a person, including health situations and preventive care gaps. */
export type CareGapsHealthSituationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Care gaps data for a person, including health situations and preventive care gaps. */
export type CareGapsPreventiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Claim = {
  __typename?: 'Claim';
  claimNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  patientFirstName: Scalars['String']['output'];
  patientLastName: Scalars['String']['output'];
  patientResponsibilityAmount?: Maybe<Scalars['Float']['output']>;
  planAllowedAmount?: Maybe<Scalars['Float']['output']>;
  planPaidAmount?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<ClaimProvider>;
  serviceEndDate?: Maybe<Scalars['Date']['output']>;
  serviceItems?: Maybe<ServiceItems>;
  serviceStartDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalChargedAmount?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ClaimConnection = {
  __typename?: 'ClaimConnection';
  /** List of claims edges. */
  edges?: Maybe<Array<Maybe<ClaimEdge>>>;
  /** Information about the page of claims. */
  pageInfo: PageInfo;
};

export type ClaimConnectionResult = ClaimResponseConnection | InvalidPaginationParameter;

/** Represents a rewards edge in a connection */
export type ClaimEdge = {
  __typename?: 'ClaimEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The node containing the actual claim data. */
  node?: Maybe<Claim>;
};

export type ClaimProvider = {
  __typename?: 'ClaimProvider';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A single claim line, representing either a professional or facility claim. */
export type ClaimResponse = {
  __typename?: 'ClaimResponse';
  /** Unique identifier for the claim. */
  claimId: Scalars['String']['output'];
  /** Sequence number within the claim, if applicable. */
  claimLineItemNumber?: Maybe<Scalars['String']['output']>;
  /** Type of the claim (e.g., professional, institutional). */
  claimTypeId?: Maybe<Scalars['String']['output']>;
  /** List of diagnosis codes and their descriptions for this claim line. */
  diagnosisCodes: Array<Maybe<CodeDesc>>;
  /** Amount paid for this claim line. */
  paidAmount?: Maybe<Scalars['Float']['output']>;
  /** Date when payment was made for this claim line. */
  paidDate?: Maybe<Scalars['Date']['output']>;
  /** Place of service code indicating where the service was rendered. */
  placeOfService?: Maybe<Scalars['String']['output']>;
  /** List of procedure codes and their descriptions for this claim line. */
  procedureCodes: Array<Maybe<CodeDesc>>;
  /** Tax ID of the provider who rendered the service. */
  providerTaxId?: Maybe<Scalars['String']['output']>;
  /** Revenue code associated with this claim line (typically for facility claims). */
  revenueCode?: Maybe<Scalars['String']['output']>;
  /** Date when the service was provided. */
  serviceDate?: Maybe<Scalars['Date']['output']>;
};

/** A connection for paginated professional claims. */
export type ClaimResponseConnection = {
  __typename?: 'ClaimResponseConnection';
  /** A list of edges. */
  edges: Array<Maybe<ClaimResponseEdge>>;
  /** Pagination information for this connection. */
  pageInfo: PageInfo;
};

/** An edge in a paginated list of facility claims. */
export type ClaimResponseEdge = {
  __typename?: 'ClaimResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The claim node at the end of the edge. */
  node: ClaimResponse;
};

/** Details of all claims for a specific person, including professional and facility claims. */
export type Claims = {
  __typename?: 'Claims';
  /** Paginated facility claims associated with the person. */
  facility?: Maybe<ClaimConnectionResult>;
  /** Paginated professional claims associated with the person. */
  professional?: Maybe<ClaimConnectionResult>;
};


/** Details of all claims for a specific person, including professional and facility claims. */
export type ClaimsFacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Details of all claims for a specific person, including professional and facility claims. */
export type ClaimsProfessionalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Unique identifier for activity or sleep mutations */
export type ClientMutationId = {
  __typename?: 'ClientMutationId';
  /** Identifier value */
  value: Scalars['ID']['output'];
};

/** A code and its human-readable description. */
export type CodeDesc = {
  __typename?: 'CodeDesc';
  /** The code value (e.g., ICD, CPT, or procedure code). */
  clinicalCode: Scalars['String']['output'];
  /** Human-readable description of the code. */
  description?: Maybe<Scalars['String']['output']>;
};

/** Content types for different messages and labels */
export enum ContentType {
  ActionRewardLabel = 'ACTION_REWARD_LABEL',
  AllRewardLabel = 'ALL_REWARD_LABEL',
  LevelRewardLabel = 'LEVEL_REWARD_LABEL',
  NoGamePeriodMessage = 'NO_GAME_PERIOD_MESSAGE',
  PopulationChangeMemberMessage = 'POPULATION_CHANGE_MEMBER_MESSAGE'
}

/** Type that describes the country object */
export type Country = Node & {
  __typename?: 'Country';
  /** Country code */
  code?: Maybe<Scalars['String']['output']>;
  /** Country cookie policy requirement */
  cookiePolicy: Scalars['Boolean']['output'];
  /** Country ID */
  id: Scalars['ID']['output'];
  /** Country name */
  name: Scalars['String']['output'];
  /** Country phone code */
  phoneCode?: Maybe<Scalars['String']['output']>;
  /** Country store url */
  storeUrl?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items */
export type CountryConnection = {
  __typename?: 'CountryConnection';
  /** A list of edges */
  edges: Array<CountryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection */
export type CountryEdge = {
  __typename?: 'CountryEdge';
  /** A Cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Country;
};

/** Input for creating health measurements */
export type CreateHealthMeasurementsInput = {
  measurements: Array<InputMaybe<HealthMeasurementInput>>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  region: Region;
  sourceService?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['String']['input'];
};

/** Input for enrolling a member */
export type CreateMemberInput = {
  /** Client created identifier for this event. Must be unique per mutation. */
  clientMutationId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  sponsorExternalId: Scalars['UUID']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMemberMutationResult = CreateMemberSuccessResult | DuplicateEmailAddress | DuplicateUsername | InvalidData | MemberAlreadyEnrolled | MissingRequiredFields | NoMatchingEligibilityRecord | RegistrationClosed | UnsupportedConfiguration;

/** Return type indicating successful enrollment */
export type CreateMemberSuccessResult = {
  __typename?: 'CreateMemberSuccessResult';
  /** External member identifier value */
  externalMemberId: Scalars['ID']['output'];
};

export type CreateRecommendationInteraction = RecommendationInteractionResult | RecommendationNotFound;

/** Input type for creating a recommendation interaction */
export type CreateRecommendationInteractionInput = {
  interactionType: InteractionType;
  recommendationId: Scalars['ID']['input'];
  recommendationType: RecommendationType;
};

export type CustomResources = {
  __typename?: 'CustomResources';
  link: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Type of Data Collection Methods */
export enum DataCollectionMethod {
  Bacwav = 'BACWAV',
  Dev = 'DEV',
  Hkt = 'HKT',
  Icr = 'ICR',
  Lbk = 'LBK',
  Lrf = 'LRF',
  Man = 'MAN',
  Mfp = 'MFP',
  Ohp = 'OHP',
  Ost = 'OST',
  Pcp = 'PCP',
  Phm = 'PHM',
  Unk = 'UNK',
  Wav = 'WAV'
}

/** Types of dismissible messages */
export enum DismissibleMessageType {
  PopulationChange = 'POPULATION_CHANGE'
}

/** Return type indicating error state where provided email address is already in use */
export type DuplicateEmailAddress = {
  __typename?: 'DuplicateEmailAddress';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Return type indicating error state where provided username is already in use */
export type DuplicateUsername = {
  __typename?: 'DuplicateUsername';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Response object for the enrollment information */
export type EnrollmentStatus = {
  __typename?: 'EnrollmentStatus';
  /** True or false value that represent whether or not the member is enrolled into the platform */
  enrolled?: Maybe<Scalars['Boolean']['output']>;
  /** Current status of the searched member */
  status?: Maybe<ProfileStatus>;
};

export type EnrollmentStatusResult = EnrollmentStatus | ErrorResponse;

export type ErrorMessage = {
  /** Error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Type that describes error response. */
export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  /** Error message of the response */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Http error status of the response. */
  errorStatus?: Maybe<HttpStatus>;
};

export type EvaluatedFeatureToggle = {
  __typename?: 'EvaluatedFeatureToggle';
  enabled: Scalars['Boolean']['output'];
  featureTogglePayload: FeatureTogglePayload;
  name: Scalars['String']['output'];
};

export type FeatureTogglePayload = {
  __typename?: 'FeatureTogglePayload';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  payloadType: Scalars['String']['output'];
};

/** Field error */
export type FieldError = {
  __typename?: 'FieldError';
  /** An error code */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** An error message for field */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** A field name */
  field?: Maybe<Scalars['String']['output']>;
};

export type FindCareFeatures = {
  __typename?: 'FindCareFeatures';
  hasFindCare?: Maybe<Scalars['Boolean']['output']>;
  hasFindCareDoctor?: Maybe<Scalars['Boolean']['output']>;
  hasFindCareOnlineDoctor?: Maybe<Scalars['Boolean']['output']>;
  hasFindCareProcedure?: Maybe<Scalars['Boolean']['output']>;
};

/** Types of game campaign action selection. All, by category or by action */
export enum GameCampaignActionSelectionType {
  Actions = 'ACTIONS',
  All = 'ALL',
  Categories = 'CATEGORIES'
}

/** Types of game campaigns */
export enum GameCampaignType {
  DoublePoints = 'DOUBLE_POINTS'
}

/** Type representing game campaigns information */
export type GameCampaigns = {
  __typename?: 'GameCampaigns';
  /** Detailed description of the campaign */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines how actions are selected for this campaign */
  gameCampaignActionSelectionType?: Maybe<GameCampaignActionSelectionType>;
  /** The type of game campaign */
  gameCampaignType?: Maybe<GameCampaignType>;
  /** Unique identifier of the game campaign */
  id: Scalars['Long']['output'];
  /** Indicates if the campaign is visible to all members */
  isPublic: Scalars['Boolean']['output'];
  /** Indicates if the campaign should be shown to the member today */
  shouldShowGameCampaignToday: Scalars['Boolean']['output'];
  /** Title of the game campaign */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents content elements associated with a game, such as text or hyperlinks */
export type GameContent = {
  __typename?: 'GameContent';
  /** The actual content data */
  content?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the game content */
  id: Scalars['Long']['output'];
  /** The order in which this content should appear By default GameContent is returned in the correct order. */
  orderIndex: Scalars['Int']['output'];
  /** Reference to the reward population */
  rewardPopulationId?: Maybe<Scalars['Long']['output']>;
};

/** Represents the title and descriptive text for a game that explains its purpose and rules to members */
export type GameDescription = {
  __typename?: 'GameDescription';
  /** Detailed description of the game */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the game description */
  id: Scalars['Long']['output'];
  /** Title of the game */
  title?: Maybe<Scalars['String']['output']>;
};

/** Game features available in the system */
export enum GameFeature {
  CareCompliance = 'CARE_COMPLIANCE',
  FamilyRewardCap = 'FAMILY_REWARD_CAP',
  GatedLevelRewards = 'GATED_LEVEL_REWARDS',
  GatedRewards = 'GATED_REWARDS',
  Initiatives = 'INITIATIVES',
  InitiativeTiers = 'INITIATIVE_TIERS',
  RequiredByPartner = 'REQUIRED_BY_PARTNER',
  RequiredInitiatives = 'REQUIRED_INITIATIVES'
}

/** Types of Gender Identities */
export enum GenderIdentity {
  DoNotIdentifyAsMaleOrFemale = 'DO_NOT_IDENTIFY_AS_MALE_OR_FEMALE',
  Female = 'FEMALE',
  Male = 'MALE',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER'
}

/** Type that describes the gender identity object */
export type GenderIdentityDescriptor = Node & {
  __typename?: 'GenderIdentityDescriptor';
  /** Specifies if gender identity is binary */
  binary?: Maybe<Scalars['Boolean']['output']>;
  /** Gender identity description */
  description?: Maybe<Scalars['String']['output']>;
  /** Gender identity code */
  genderCode?: Maybe<Scalars['String']['output']>;
  /** Gender identity name */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items */
export type GenderIdentityDescriptorConnection = {
  __typename?: 'GenderIdentityDescriptorConnection';
  /** A list of edges */
  edges: Array<GenderIdentityDescriptorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection */
export type GenderIdentityDescriptorEdge = {
  __typename?: 'GenderIdentityDescriptorEdge';
  /** A Cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GenderIdentityDescriptor;
};

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

/** A type representing a single HealthMeasurement object */
export type HealthMeasurement = {
  __typename?: 'HealthMeasurement';
  /** Created date. */
  createdDate?: Maybe<Scalars['String']['output']>;
  /** Data collection method. Enumerated in db. */
  dataCollectionMethod?: Maybe<DataCollectionMethod>;
  /** HealthMeasurement UUID */
  id?: Maybe<Scalars['UUID']['output']>;
  /** Measurement date. */
  measurementDate: Scalars['String']['output'];
  /** Member id */
  memberId?: Maybe<Scalars['Long']['output']>;
  /** Person id */
  personId?: Maybe<Scalars['Long']['output']>;
  /** Source id. Will link to further information in Ingestion. */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Source service. Enumerated in db. */
  sourceService?: Maybe<Scalars['String']['output']>;
  /** Source type. Enumerated in db. */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** Type of HealthMeasurement (enum) */
  type: HealthMeasurementType;
  /** Updated date. */
  updatedDate?: Maybe<Scalars['String']['output']>;
  /** Value of HealthMeasurement */
  value: Scalars['Float']['output'];
};

/** Input for individual health measurements in CreateHealthMeasurementsInput */
export type HealthMeasurementInput = {
  dataCollectionMethod: Scalars['String']['input'];
  measurementDate: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

/** Type of Health Measurement Types */
export enum HealthMeasurementType {
  A1C = 'A1C',
  Bmi = 'BMI',
  BloodPressurePulse = 'BloodPressurePulse',
  BodyFat = 'BodyFat',
  BodyTemperature = 'BodyTemperature',
  CholesterolHdl = 'CholesterolHDL',
  CholesterolLdl = 'CholesterolLDL',
  CholesterolTotal = 'CholesterolTotal',
  CholesterolTriglyceride = 'CholesterolTriglyceride',
  DiastolicBloodPressure = 'DiastolicBloodPressure',
  GlucoseFasting = 'GlucoseFasting',
  GlucoseNonFasting = 'GlucoseNonFasting',
  Height = 'Height',
  HipCircumference = 'HipCircumference',
  SystolicBloodPressure = 'SystolicBloodPressure',
  TobaccoUser = 'TobaccoUser',
  WaistCircumference = 'WaistCircumference',
  Weight = 'Weight'
}

/** Health situation data, including associated care gaps. */
export type HealthSituation = {
  __typename?: 'HealthSituation';
  /** List of care gaps associated with this health condition. */
  careGaps: Array<CareGapDetails>;
  /** Name of the health condition. */
  healthConditionName?: Maybe<Scalars['String']['output']>;
};

/** Connection type for health situation care gaps. */
export type HealthSituationConnection = {
  __typename?: 'HealthSituationConnection';
  /** List of health situation edges. */
  edges: Array<HealthSituationEdge>;
  /** Pagination information for the connection. */
  pageInfo: PageInfo;
};

/** Edge type for health situation care gaps. */
export type HealthSituationEdge = {
  __typename?: 'HealthSituationEdge';
  /** Cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** Health situation data. */
  node: HealthSituation;
};

/** Result of a health situation query, either a connection or an error. */
export type HealthSituationResult = HealthSituationConnection | InvalidPaginationParameter;

export type HraPreferredNameVm = {
  __typename?: 'HraPreferredNameVM';
  abbreviation?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
};

/** Type of http statuses. */
export enum HttpStatus {
  BadRequest = 'BAD_REQUEST',
  Forbidden = 'FORBIDDEN',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED'
}

export type InsurancePlan = {
  __typename?: 'InsurancePlan';
  attachments?: Maybe<Array<Maybe<InsurancePlanAttachment>>>;
  coverage?: Maybe<InsurancePlanCoverage>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  subscriber?: Maybe<InsurancePlanMember>;
  type?: Maybe<InsurancePlanType>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlanAccumulators = {
  __typename?: 'InsurancePlanAccumulators';
  accumulatorData: Array<Maybe<InsurancePlanAccumulatorsCoverage>>;
  lastUpdate: Scalars['Date']['output'];
  planId: Scalars['Int']['output'];
  planLevel: Scalars['String']['output'];
};

export type InsurancePlanAccumulatorsCoverage = {
  __typename?: 'InsurancePlanAccumulatorsCoverage';
  accumulatorName?: Maybe<Scalars['String']['output']>;
  applied?: Maybe<Scalars['String']['output']>;
  coverage: Scalars['String']['output'];
  level: Scalars['String']['output'];
  limit?: Maybe<Scalars['String']['output']>;
  network: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  remaining?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlanAttachment = {
  __typename?: 'InsurancePlanAttachment';
  format?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlanConnection = {
  __typename?: 'InsurancePlanConnection';
  data?: Maybe<Array<Maybe<InsurancePlan>>>;
};

export type InsurancePlanCoverage = {
  __typename?: 'InsurancePlanCoverage';
  amounts: Array<Maybe<InsurancePlanCoverageAmount>>;
  showAccumulators: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InsurancePlanCoverageAmount = {
  __typename?: 'InsurancePlanCoverageAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  coverage: Scalars['String']['output'];
  customLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  network: Scalars['String']['output'];
  planLevel: Scalars['String']['output'];
};

export type InsurancePlanFeatures = {
  __typename?: 'InsurancePlanFeatures';
  hasDentalInsurancePlan: Scalars['Boolean']['output'];
  hasIdCards: Scalars['Boolean']['output'];
  hasInsuranceClaims: Scalars['Boolean']['output'];
  hasMedicalInsurancePlan: Scalars['Boolean']['output'];
  hasPharmacyInsurancePlan: Scalars['Boolean']['output'];
  hasVisionInsurancePlan: Scalars['Boolean']['output'];
};

export type InsurancePlanMember = {
  __typename?: 'InsurancePlanMember';
  active?: Maybe<Scalars['Boolean']['output']>;
  consent?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  effectiveEndDate?: Maybe<Scalars['Date']['output']>;
  effectiveStartDate?: Maybe<Scalars['Date']['output']>;
  enterprisePersonId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  primarySubscriber?: Maybe<Scalars['Boolean']['output']>;
  subscriberId?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlanMemberConnection = {
  __typename?: 'InsurancePlanMemberConnection';
  data?: Maybe<Array<Maybe<InsurancePlanMember>>>;
};

export type InsurancePlanResources = {
  __typename?: 'InsurancePlanResources';
  insuranceCardBack?: Maybe<Scalars['String']['output']>;
  insuranceCardFront?: Maybe<Scalars['String']['output']>;
  prescriptionDrugList?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<CustomResources>>>;
  summaryOfBenefits?: Maybe<Scalars['String']['output']>;
  summaryPlanDescription?: Maybe<Scalars['String']['output']>;
};

export enum InsurancePlanType {
  Dental = 'Dental',
  Medical = 'Medical',
  Pharmacy = 'Pharmacy',
  Vision = 'Vision'
}

/** Represents different types of interactions a user can have with a recommendation */
export enum InteractionType {
  /** Represents when a member has made an interaction with a recommendation */
  Accepted = 'ACCEPTED',
  /** Represents when the member has chosen an Not Now with a recommendation */
  Later = 'LATER',
  /** Represents when the member has added an Recommend Healthy Habit into their Healthy Habit list */
  ListAdded = 'LIST_ADDED',
  /** Represents when the member has not interacted with an recommendation for 2 weeks */
  Never = 'NEVER'
}

/** Return type indicating error state where some of the provided or eligibility fields are invalid */
export type InvalidData = {
  __typename?: 'InvalidData';
  /** Fields that are invalid */
  invalidFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** Return type indicating an error state where provided pagination parameters are not valid. Validation rules: - Both 'first' and 'last' parameters cannot be provided simultaneously. - First takes a non-negative integer. - After takes the Cursor type. - Last takes a non-negative integer. - Before takes the Cursor type. - First/last parameter value should be between 0 and Max. */
export type InvalidPaginationParameter = ErrorMessage & {
  __typename?: 'InvalidPaginationParameter';
  /** Error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Validation rule description. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Type that describes the language object */
export type LanguageDescriptor = Node & {
  __typename?: 'LanguageDescriptor';
  /** Language code */
  code?: Maybe<Scalars['String']['output']>;
  /** Language description */
  description?: Maybe<Scalars['String']['output']>;
  /** Language english name */
  englishNative?: Maybe<Scalars['String']['output']>;
  /** Language name */
  id: Scalars['ID']['output'];
  /** Specifies if language is selectable */
  selectable?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items */
export type LanguageDescriptorConnection = {
  __typename?: 'LanguageDescriptorConnection';
  /** A list of edges */
  edges: Array<LanguageDescriptorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection */
export type LanguageDescriptorEdge = {
  __typename?: 'LanguageDescriptorEdge';
  /** A Cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LanguageDescriptor;
};

/** Measurement units for various measurement types */
export enum MeasurementUnit {
  Count = 'COUNT',
  Kilocalorie = 'KILOCALORIE',
  Meter = 'METER',
  Millimeter = 'MILLIMETER',
  Millisecond = 'MILLISECOND'
}

/** Represents the aggregate plan-paid amount for medical claims within a specific period. */
export type MedicalClaimsIncurredCost = {
  __typename?: 'MedicalClaimsIncurredCost';
  /** The time period (such as a year) for which the medical claims cost is calculated. */
  timePeriod: Scalars['String']['output'];
  /** The total amount paid by the plan for claims incurred during the specified period. */
  totalPlanPaidAmount: Scalars['Float']['output'];
};

/** Represents the currently active reward program and game for a member. */
export type MemberActiveProgramAndGame = {
  __typename?: 'MemberActiveProgramAndGame';
  /** Date when the program ends */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Game associated with this program for the member */
  game?: Maybe<MemberGame>;
  /** Message displayed when there is no active game */
  noActiveGamePeriodMessage?: Maybe<NoActiveGamePeriodMessage>;
  /** Unique identifier of the reward program */
  programId: Scalars['Long']['output'];
  /** Display names for different reward types in this program */
  rewardTypeDisplayNames: Array<Maybe<RewardTypeDisplayName>>;
  /** Date when the program begins */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type MemberActiveProgramAndGameResult = ActiveGameNotFound | ActiveProgramNotFound | ErrorResponse | MemberActiveProgramAndGame | MemberNotFound;

export type MemberActivityMutationResult = ClientMutationId | ProviderAndVendorNotMatching;

/** Return type indicating error state where the member is already enrolled */
export type MemberAlreadyEnrolled = {
  __typename?: 'MemberAlreadyEnrolled';
  /** Error message */
  message: Scalars['String']['output'];
};

export type MemberBenefitsFeatures = {
  __typename?: 'MemberBenefitsFeatures';
  findCareFeatures: FindCareFeatures;
  insurancePlanFeatures: InsurancePlanFeatures;
};

/** Type representing dismissible messages for members */
export type MemberDismissibleMessage = {
  __typename?: 'MemberDismissibleMessage';
  /** Unique identifier of the message */
  id: Scalars['Long']['output'];
  /** Identifier of the member this message is for */
  memberId?: Maybe<Scalars['Long']['output']>;
  /** Type of dismissible message */
  messageType?: Maybe<DismissibleMessageType>;
};

/** Represents a game assigned to a member as part of a reward program */
export type MemberGame = {
  __typename?: 'MemberGame';
  /** Date when the game ends */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Game Campaigns associated with this game */
  gameCampaigns?: Maybe<Array<Maybe<GameCampaigns>>>;
  /** Content elements associated with this game */
  gameContent?: Maybe<Array<Maybe<GameContent>>>;
  /** Description details for this game */
  gameDescription?: Maybe<GameDescription>;
  /** Features enabled for this game */
  gameFeatures?: Maybe<Array<Maybe<GameFeature>>>;
  /** Unique identifier of the game */
  id: Scalars['Long']['output'];
  /** Messages that can be dismissed by the member */
  memberDismissableMessages?: Maybe<Array<Maybe<MemberDismissibleMessage>>>;
  /** Name of the game */
  name?: Maybe<Scalars['String']['output']>;
  /** Reference to the reward program this game belongs to */
  programId: Scalars['Long']['output'];
  /** Labels for different rewards in this game */
  rewardLabels?: Maybe<Array<Maybe<RewardLabels>>>;
  /** Identifier for the reward population */
  rewardPopulationId?: Maybe<Scalars['Long']['output']>;
  /** Date when the game begins */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type MemberInsuranceConsent = {
  __typename?: 'MemberInsuranceConsent';
  consent?: Maybe<Scalars['String']['output']>;
  dateOfConsent?: Maybe<Scalars['Date']['output']>;
  memberId?: Maybe<Scalars['Int']['output']>;
};

/** Return type indicating an error state when member is not found. */
export type MemberNotFound = ErrorMessage & {
  __typename?: 'MemberNotFound';
  /** Error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Input type for creating recommendations for members */
export type MemberRecommendationsInput = {
  recommendationCount?: InputMaybe<Scalars['Int']['input']>;
  recommendationType: RecommendationType;
  source: RecommendationSourceType;
};

export type MemberSettings = {
  __typename?: 'MemberSettings';
  hasSeenDomainNavigationMobile?: Maybe<Scalars['Boolean']['output']>;
  hasSeenDomainNavigationWeb?: Maybe<Scalars['Boolean']['output']>;
  hasSeenGoalSetting?: Maybe<Scalars['Boolean']['output']>;
  hideOnboardingItems?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isNicotineFree?: Maybe<Scalars['Boolean']['output']>;
  lastSeenCompanyUpdates?: Maybe<Scalars['Void']['output']>;
  lastSeenNewFeature?: Maybe<Scalars['Void']['output']>;
  lastSeenTrackerChallengeRecommendation?: Maybe<Scalars['Void']['output']>;
  onboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  showTimezoneAlert?: Maybe<Scalars['Boolean']['output']>;
  stepsGoal?: Maybe<Scalars['Int']['output']>;
  themeId?: Maybe<Scalars['Void']['output']>;
};

/** Metric data */
export type Metric = {
  origin: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Source of metric data */
export type MetricSource = {
  device?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type MetricUpdateResult = {
  __typename?: 'MetricUpdateResult';
  value: Scalars['Int']['output'];
};

/** Return type indicating error state where provided information is lacking some of the required fields */
export type MissingRequiredFields = {
  __typename?: 'MissingRequiredFields';
  /** Error message */
  message: Scalars['String']['output'];
  /** Required fields that are missing */
  missingFields: Array<Scalars['String']['output']>;
};

/** GraphQL Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Mutation to create new HealthMeasurements. */
  createHealthMeasurements?: Maybe<ProducerResponse>;
  /** Mutation to enroll a member */
  createMember?: Maybe<CreateMemberMutationResult>;
  /** Creates a new recommendation interaction */
  createRecommendationInteraction: CreateRecommendationInteraction;
  /** Mutation to create or update activity data */
  updateActivity?: Maybe<MemberActivityMutationResult>;
  /** Mutation to create or update metrics */
  updateMetrics?: Maybe<MetricUpdateResult>;
  /** Mutation for updating current user profile */
  updateProfile?: Maybe<UpdateProfileResponse>;
  /** Mutation to create or update sleep data */
  updateSleep?: Maybe<MemberActivityMutationResult>;
};


/** GraphQL Mutations */
export type MutationCreateHealthMeasurementsArgs = {
  healthMeasurements: CreateHealthMeasurementsInput;
};


/** GraphQL Mutations */
export type MutationCreateMemberArgs = {
  input: CreateMemberInput;
};


/** GraphQL Mutations */
export type MutationCreateRecommendationInteractionArgs = {
  input: CreateRecommendationInteractionInput;
};


/** GraphQL Mutations */
export type MutationUpdateActivityArgs = {
  activityUpdate: UpdateActivityInput;
};


/** GraphQL Mutations */
export type MutationUpdateMetricsArgs = {
  metricUpdate: UpdateMetricInput;
};


/** GraphQL Mutations */
export type MutationUpdateProfileArgs = {
  input?: InputMaybe<UpdateProfileInput>;
};


/** GraphQL Mutations */
export type MutationUpdateSleepArgs = {
  sleepUpdate: UpdateSleepInput;
};

/** Message displayed when there is no active game */
export type NoActiveGamePeriodMessage = {
  __typename?: 'NoActiveGamePeriodMessage';
  /** Content to display when there is no active game period */
  content?: Maybe<Scalars['String']['output']>;
  /** End date of the last game that ended */
  lastRewardingPeriodEndDate?: Maybe<Scalars['Date']['output']>;
};

/** Return type indicating error state where provided information does not match an existing eligibility record */
export type NoMatchingEligibilityRecord = {
  __typename?: 'NoMatchingEligibilityRecord';
  /** Error message */
  message: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

/** Object for PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** A cursor identifying the last item in the current page. Should be used when paginating forward. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether there are more items after the current page. Calculated only when paginating forward. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether there are more items before the current page. Calculated only when paginating backward. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** A cursor identifying the first item in the current page. Should be used when paginating backward. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Member phone settings */
export type PhoneSettings = {
  __typename?: 'PhoneSettings';
  /** Phone home number */
  homeNumber?: Maybe<Scalars['String']['output']>;
  /** Phone home number iso code */
  homeNumberIsoCode?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number iso code */
  mobileNumberIsoCode?: Maybe<Scalars['String']['output']>;
  /** Specifies if mobile phone number is verified */
  mobileNumberVerified?: Maybe<Scalars['Boolean']['output']>;
};

/** A response type returned after creating new HealthMeasurements detailing the payload that was sent and where. */
export type ProducerResponse = {
  __typename?: 'ProducerResponse';
  /** Payload that was sent. */
  payload?: Maybe<Scalars['String']['output']>;
  /** Region the payload was sent to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Topic the payload was sent to. */
  topic?: Maybe<Scalars['String']['output']>;
};

/** Type that describes the profile object */
export type Profile = {
  __typename?: 'Profile';
  /** Member's bio */
  bio?: Maybe<Scalars['String']['output']>;
  /** Member's country */
  country?: Maybe<Country>;
  /** Member's date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email address of the member */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Date when the member enrolled onto the platform */
  enrollmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier used on platform level */
  enterprisePersonId?: Maybe<Scalars['String']['output']>;
  /** Identifier used for external transactions */
  externalId?: Maybe<Scalars['String']['output']>;
  /** First name of the member */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender which member identifies as */
  genderIdentity?: Maybe<GenderIdentity>;
  /** Profile id */
  id: Scalars['ID']['output'];
  /** Member's preferred language */
  language?: Maybe<LanguageDescriptor>;
  /** Last name of the member */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Member id */
  memberId: Scalars['ID']['output'];
  /** Person id */
  personId: Scalars['ID']['output'];
  /** Phone settings */
  phoneSettings?: Maybe<PhoneSettings>;
  /** Member's profile picture */
  picture?: Maybe<Scalars['String']['output']>;
  /** Sponsor id */
  sponsorId?: Maybe<Scalars['ID']['output']>;
  /** Member's timezone */
  timezone?: Maybe<TimezoneDescriptor>;
  /** Which system of measurement the member prefers */
  unitOfMeasurement?: Maybe<UnitOfMeasurement>;
  /** Username of the member */
  username?: Maybe<Scalars['String']['output']>;
};

/** List of possible values a member status can be in */
export enum ProfileStatus {
  /** Member is active in the platform */
  Active = 'ACTIVE',
  /** Member is excluded from the platform */
  Cancelled = 'CANCELLED',
  /** Member is active but going to be excluded from the platform after a certain period */
  PendingCancel = 'PENDING_CANCEL'
}

/** Return type indicating an error state where different provider and vendor values were given for mutation input */
export type ProviderAndVendorNotMatching = {
  __typename?: 'ProviderAndVendorNotMatching';
  /** Error message */
  message: Scalars['String']['output'];
  /** Provider provided with input */
  provider: ActivityProvider;
  /** Vendor provided with input */
  vendor: ActivityVendor;
};

/** GraphQL Queries */
export type Query = {
  __typename?: 'Query';
  /** Test query, always returns null */
  activity?: Maybe<Scalars['String']['output']>;
  benefitPagesSponsorSettings?: Maybe<BenefitPagesSponsorSettings>;
  /** Retrieves care gaps for a given enterprise person ID. */
  careGapsByEPID?: Maybe<CareGaps>;
  /** Retrieves the claims detail for a given enterprise person ID, including both professional and facility claims. */
  claimsDetail?: Maybe<Claims>;
  /** Query for fetching list of countries */
  countries: CountryConnection;
  /** Query for fetching the enrollment status to see if the member is enrolled on the platform */
  enrollmentStatusByEmployeeId?: Maybe<EnrollmentStatusResult>;
  featureToggles: Array<Maybe<EvaluatedFeatureToggle>>;
  /** Query for fetching list of genders */
  genders: GenderIdentityDescriptorConnection;
  /** Query for health measurements by personId. Optionally filters by UTC start date, UTC end date, and/or type. Date formatting: "yyyy-MM-dd" */
  healthMeasurements: Array<Maybe<HealthMeasurement>>;
  insuranceClaims?: Maybe<ClaimConnection>;
  insurancePlan?: Maybe<InsurancePlan>;
  insurancePlanAccumulators?: Maybe<InsurancePlanAccumulators>;
  insurancePlanMembers?: Maybe<InsurancePlanMemberConnection>;
  insurancePlans?: Maybe<InsurancePlanConnection>;
  /** Query for fetching a flag used to determine if member date is to be update from member-profile mfe (if false) or using external app */
  isExternallySyncedMember: Scalars['Boolean']['output'];
  /** Query for fetching list of languages */
  languages: LanguageDescriptorConnection;
  /** Retrieves the total plan-paid amounts for all medical claims incurred by the specified enterprise person, grouped by period (e.g., year). */
  medicalClaimsIncurredCost: Array<Maybe<MedicalClaimsIncurredCost>>;
  /** Active reward program. A time period (commonly one year) defined for a sponsor which can contain 1+ games. Always returns active program and game. */
  memberActiveProgramAndGame?: Maybe<MemberActiveProgramAndGameResult>;
  memberBenefitsFeatures?: Maybe<MemberBenefitsFeatures>;
  memberInsuranceConsent?: Maybe<MemberInsuranceConsent>;
  memberSettings?: Maybe<MemberSettings>;
  memberSponsor?: Maybe<Sponsor>;
  /** Query for fetching current user profile */
  profile?: Maybe<Profile>;
  /** Retrieves personalized recommendations for a member based on the optional type and count. */
  recommendations?: Maybe<Array<Maybe<Recommendation>>>;
  /** sayHealthNotes is a dummy field with no controller to fulfill it. It is here to avoid an empty schema issue and will return null by default unless you add a controller or remove it entirely. Recommendation: Remove it entirely after adding your first legitimate field. */
  sayHealthNotes?: Maybe<Scalars['String']['output']>;
  /** Test query, always returns null */
  sleep?: Maybe<Scalars['String']['output']>;
  sponsorSettings?: Maybe<SponsorSettings>;
  /** Test query, returns Ok if successful */
  syntheticContentInteraction?: Maybe<Scalars['String']['output']>;
  /** Test query, always returns "Ok" */
  syntheticEnrollment?: Maybe<Scalars['String']['output']>;
  /** Test query, always returns Ok Subject to unannounced changes. */
  syntheticHPS?: Maybe<Scalars['String']['output']>;
  /** Test query, always returns Ok Subject to unannounced changes. */
  syntheticR?: Maybe<Scalars['String']['output']>;
  /** Test query, always returns null Subject to unannounced changes. */
  syntheticU?: Maybe<Scalars['String']['output']>;
  /** created test end point for Claims */
  testEndpointClaims?: Maybe<TestEndpointClaimsResult>;
  /** created test end point for PCDM */
  testEndpointPCDM?: Maybe<TestEndpointPcdmResult>;
  /** Query for fetching list of timezones */
  timezones: TimezoneDescriptorConnection;
  /** Retrieves the top diagnosis names for medical claims associated with a given enterprise person, grouped by period (e.g. year). */
  topPlanPaidDiagnosisAmountGroupByTimePeriod: Array<Maybe<TopPlanPaidDiagnosis>>;
  trophies?: Maybe<Array<Maybe<Trophy>>>;
  /** Query for fetching list of unit of measurements */
  unitOfMeasurements: UnitOfMeasurementDescriptorConnection;
};


/** GraphQL Queries */
export type QueryCareGapsByEpidArgs = {
  epid: Scalars['String']['input'];
};


/** GraphQL Queries */
export type QueryClaimsDetailArgs = {
  enterprisePersonId: Scalars['String']['input'];
};


/** GraphQL Queries */
export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** GraphQL Queries */
export type QueryEnrollmentStatusByEmployeeIdArgs = {
  employeeId: Scalars['ID']['input'];
};


/** GraphQL Queries */
export type QueryGendersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withNonBinary?: Scalars['Boolean']['input'];
};


/** GraphQL Queries */
export type QueryHealthMeasurementsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  personId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<HealthMeasurementType>;
};


/** GraphQL Queries */
export type QueryInsuranceClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL Queries */
export type QueryInsurancePlanArgs = {
  planId?: InputMaybe<Scalars['Int']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL Queries */
export type QueryInsurancePlanAccumulatorsArgs = {
  enterprisePersonId?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL Queries */
export type QueryInsurancePlanMembersArgs = {
  planType?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL Queries */
export type QueryLanguagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** GraphQL Queries */
export type QueryMedicalClaimsIncurredCostArgs = {
  enterprisePersonId: Scalars['String']['input'];
  sponsorId: Scalars['Long']['input'];
};


/** GraphQL Queries */
export type QueryRecommendationsArgs = {
  input?: InputMaybe<MemberRecommendationsInput>;
};


/** GraphQL Queries */
export type QuerySayHealthNotesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL Queries */
export type QueryTimezonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** GraphQL Queries */
export type QueryTopPlanPaidDiagnosisAmountGroupByTimePeriodArgs = {
  enterprisePersonId: Scalars['String']['input'];
  sponsorId: Scalars['Long']['input'];
};


/** GraphQL Queries */
export type QueryUnitOfMeasurementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a list of the recommendations. */
export type Recommendation = {
  __typename?: 'Recommendation';
  /** Description of the recommendation. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the recommendation. */
  id: Scalars['ID']['output'];
  /** Image url of the recommendation. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Unique ID associated with the recommendation. */
  recommendationId?: Maybe<Scalars['ID']['output']>;
  /** Type of the recommendation. */
  recommendationType?: Maybe<RecommendationType>;
  /** Source of the recommendation. */
  source?: Maybe<RecommendationSourceType>;
  /** Title of the recommendation. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents an interaction between a member and a recommendation */
export type RecommendationInteractionResult = {
  __typename?: 'RecommendationInteractionResult';
  /** Type of interaction (Accepted, Later, ListAdded, Never) */
  interactionType: InteractionType;
  /** Unique ID of the recommendation */
  recommendationId: Scalars['ID']['output'];
  /** Type of the recommendation */
  recommendationType: RecommendationType;
  /** Timestamp of when the interaction occurred */
  timestamp: Scalars['DateTime']['output'];
};

/** Represents If a Recommendation Interaction is Not Found */
export type RecommendationNotFound = {
  __typename?: 'RecommendationNotFound';
  /** Message to show status in response body */
  message?: Maybe<Scalars['String']['output']>;
};

/** Represents different sources from which a recommendation can originate. */
export enum RecommendationSourceType {
  /** Represents a source indicating that the recommendation is based on member interactions with the NBHA. */
  Nbha = 'NBHA'
}

/** Represents different types of recommendations a user can have */
export enum RecommendationType {
  /** Represents the benefits programs available to the member */
  BenefitPrograms = 'BenefitPrograms',
  /** Represents challenges related to healthy habits that the member can participate in */
  HabitChallenges = 'HabitChallenges',
  /** Represents healthy habits that the member can choose */
  Habits = 'Habits',
  /** Represents the interests of the member */
  Interests = 'Interests',
  /** Represents the journeys that the member can take towards achieving their goals */
  Journeys = 'Journeys',
  /** Represents various media content that can be recommended to the member */
  Media = 'Media',
  /** Represents challenges related to steps that the member can engage in */
  StepChallenges = 'StepChallenges'
}

/** Type of regions */
export enum Region {
  Eu = 'EU',
  Na = 'NA'
}

/** Return type indicating error state where registration is currently closed for the given sponsor */
export type RegistrationClosed = {
  __typename?: 'RegistrationClosed';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Type representing reward labels configuration */
export type RewardLabels = {
  __typename?: 'RewardLabels';
  /** The actual label text */
  content?: Maybe<Scalars['String']['output']>;
  /** Type of content for this reward label */
  contentType?: Maybe<ContentType>;
};

/** Type of reward that can be earned. */
export enum RewardType {
  AchieversPoints = 'ACHIEVERS_POINTS',
  CashIncentive = 'CASH_INCENTIVE',
  Entries = 'ENTRIES',
  Hra = 'HRA',
  Hsa = 'HSA',
  Hsahra = 'HSAHRA',
  MaritzCredits = 'MARITZ_CREDITS',
  NoReward = 'NO_REWARD',
  OcTannerPoints = 'OC_TANNER_POINTS',
  Points = 'POINTS',
  PremiumCredit = 'PREMIUM_CREDIT',
  PremiumDiscount = 'PREMIUM_DISCOUNT',
  PulseCash = 'PULSE_CASH',
  RedTagPoints = 'RED_TAG_POINTS',
  TextOnly = 'TEXT_ONLY'
}

/** Represents the display name mapping for a reward type */
export type RewardTypeDisplayName = {
  __typename?: 'RewardTypeDisplayName';
  /** Display name for the reward type */
  displayName: Scalars['String']['output'];
  /** The type of reward */
  type: RewardType;
};

export type ServiceItem = {
  __typename?: 'ServiceItem';
  chargedAmount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  patientResponsibilityAmount?: Maybe<Scalars['Float']['output']>;
  planAllowedAmount?: Maybe<Scalars['Float']['output']>;
  planPaidAmount?: Maybe<Scalars['Float']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type ServiceItems = {
  __typename?: 'ServiceItems';
  data?: Maybe<Array<Maybe<ServiceItem>>>;
};

/** Measurement data of sleep input */
export type SleepMeasurement = {
  /** Source App if known */
  app?: InputMaybe<Scalars['String']['input']>;
  /** Sleep spent in restless stage */
  awakeSeconds: Scalars['Int']['input'];
  deepSleepSeconds: Scalars['Int']['input'];
  /** Source Device if known */
  device?: InputMaybe<Scalars['String']['input']>;
  lightSleepSeconds: Scalars['Int']['input'];
  measurementType: SleepMeasurementType;
  /** Sleep seconds that couldn't be assigned to a particular stage */
  otherSleepSeconds: Scalars['Int']['input'];
  remSleepSeconds: Scalars['Int']['input'];
  /** Timestamp of measurement. E.g.: 1996-12-19T16:39:57-08:00 or 1996-12-19T16:39:57Z */
  timestamp: Scalars['DateTime']['input'];
  /** Is the measurement from a validated source? */
  validated: Scalars['Boolean']['input'];
};

/** Type of sleep measurement */
export enum SleepMeasurementType {
  CumulativeSleepSeconds = 'CUMULATIVE_SLEEP_SECONDS'
}

/** Service where Data is Sourced From */
export enum SourceService {
  DeviceIngestion = 'DeviceIngestion',
  FileIngestion = 'FileIngestion',
  Harmonix = 'Harmonix',
  TestApi = 'TestAPI',
  Unknown = 'Unknown'
}

/** Type of Sources */
export enum SourceType {
  AppleHealth = 'AppleHealth',
  File = 'File',
  Garmin = 'Garmin',
  GenAdmin = 'GenAdmin',
  GoogleFit = 'GoogleFit',
  HealthConnect = 'HealthConnect',
  HealthStationMobile = 'HealthStationMobile',
  Higi = 'Higi',
  MemberApp = 'MemberApp',
  Oura = 'Oura',
  Polar = 'Polar',
  SHealth = 'SHealth',
  Salesforce = 'Salesforce',
  Strava = 'Strava',
  Wellsource = 'Wellsource',
  Withings = 'Withings',
  WithingsPro = 'WithingsPro',
  IHealth = 'iHealth'
}

export type Sponsor = {
  __typename?: 'Sponsor';
  billingReference?: Maybe<Scalars['JSON']['output']>;
  coverPhotoUrl?: Maybe<Scalars['JSON']['output']>;
  demo?: Maybe<Scalars['JSON']['output']>;
  distributorId?: Maybe<Scalars['JSON']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industryId?: Maybe<Scalars['Float']['output']>;
  legacyId?: Maybe<Scalars['Float']['output']>;
  logoUrl?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<Scalars['JSON']['output']>;
  pillarConfigurations?: Maybe<Scalars['JSON']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  productEdition?: Maybe<Scalars['String']['output']>;
  productLaunchDate?: Maybe<Scalars['JSON']['output']>;
  sponsorImageUrls?: Maybe<Scalars['JSON']['output']>;
  sponsorOnboardingItems?: Maybe<Scalars['JSON']['output']>;
  sponsorSettingsId?: Maybe<Scalars['Float']['output']>;
  sponsorSettingsUI?: Maybe<SponsorSettingsUi>;
  sponsorSupportEmailSettings?: Maybe<Scalars['JSON']['output']>;
  sponsorType?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['JSON']['output']>;
  supportPageLink?: Maybe<Scalars['JSON']['output']>;
  supportPhone?: Maybe<Scalars['JSON']['output']>;
  themeId?: Maybe<Scalars['JSON']['output']>;
};

export type SponsorSettings = {
  __typename?: 'SponsorSettings';
  agreementsVersion?: Maybe<Scalars['String']['output']>;
  allowNonBinaryGender?: Maybe<Scalars['Boolean']['output']>;
  allowNonBinaryGenderInSurvey?: Maybe<Scalars['Boolean']['output']>;
  allowPhoneNumberCollection?: Maybe<Scalars['Boolean']['output']>;
  allowSendingEmployeeIdToPartners?: Maybe<Scalars['Boolean']['output']>;
  allowSyncBiometricData?: Maybe<Scalars['Boolean']['output']>;
  authenticationProvider?: Maybe<Scalars['String']['output']>;
  billingModel?: Maybe<Scalars['String']['output']>;
  biometricLogin?: Maybe<Scalars['Boolean']['output']>;
  brandedPlatformName?: Maybe<Scalars['String']['output']>;
  coachesCornerInternationalMode?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  customDeidentificationDuration?: Maybe<Scalars['Void']['output']>;
  customLogoutUrl?: Maybe<Scalars['Void']['output']>;
  deidentificationDuration?: Maybe<Scalars['Int']['output']>;
  devicePromo?: Maybe<Scalars['String']['output']>;
  disableMobileOfflineMode?: Maybe<Scalars['Boolean']['output']>;
  displayCovidVaccinationQuestion?: Maybe<Scalars['Boolean']['output']>;
  displayCovidVaccinationStatus?: Maybe<Scalars['Boolean']['output']>;
  displayCustomCompanyLabel?: Maybe<Scalars['Void']['output']>;
  displayMissingStepsLink?: Maybe<Scalars['Boolean']['output']>;
  displayReasonableAlternativeText?: Maybe<Scalars['Boolean']['output']>;
  enableBenefitsNavigation?: Maybe<Scalars['Boolean']['output']>;
  enableChallengeChat?: Maybe<Scalars['Boolean']['output']>;
  enableChatSupport?: Maybe<Scalars['Boolean']['output']>;
  enableDataRequestForm?: Maybe<Scalars['Boolean']['output']>;
  enableDefaultSuggestedTopics?: Maybe<Scalars['Boolean']['output']>;
  enableDeidentification?: Maybe<Scalars['Boolean']['output']>;
  enableDomainNavigation?: Maybe<Scalars['Boolean']['output']>;
  enableHomepageRedesign?: Maybe<Scalars['Boolean']['output']>;
  enableIdeasLabTab?: Maybe<Scalars['Boolean']['output']>;
  enableInviteColleagues?: Maybe<Scalars['Boolean']['output']>;
  enablePassportProduct?: Maybe<Scalars['Boolean']['output']>;
  enablePhotoUpload?: Maybe<Scalars['Boolean']['output']>;
  enableResponsiveNavbar?: Maybe<Scalars['Boolean']['output']>;
  enableTruncatedLegacyEnrollment?: Maybe<Scalars['Boolean']['output']>;
  enableVaccinationCard?: Maybe<Scalars['Boolean']['output']>;
  enableVouchers?: Maybe<Scalars['Boolean']['output']>;
  enableVpNavigate?: Maybe<Scalars['Boolean']['output']>;
  enrollmentRegion?: Maybe<Scalars['String']['output']>;
  enrollmentSearch?: Maybe<Scalars['String']['output']>;
  excludeMixpanelTracking?: Maybe<Scalars['Boolean']['output']>;
  externalReferenceId?: Maybe<Scalars['Void']['output']>;
  friendsModule?: Maybe<Scalars['Boolean']['output']>;
  genesisOnly?: Maybe<Scalars['Boolean']['output']>;
  hasAchEnabled?: Maybe<Scalars['Boolean']['output']>;
  hasDonationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  hasGoalSettingModule?: Maybe<Scalars['Boolean']['output']>;
  hasGroupsModule?: Maybe<Scalars['Boolean']['output']>;
  hasHealthRiskBundle?: Maybe<Scalars['Boolean']['output']>;
  hasHub?: Maybe<Scalars['Boolean']['output']>;
  hasLiveServicesCoaching?: Maybe<Scalars['Boolean']['output']>;
  hasManualWorkoutRewards?: Maybe<Scalars['Boolean']['output']>;
  hasPromotedTrackerChallenges?: Maybe<Scalars['Boolean']['output']>;
  hasRewardFlyoutEnabled?: Maybe<Scalars['Boolean']['output']>;
  hasSleepModule?: Maybe<Scalars['Boolean']['output']>;
  hasSupporterModule?: Maybe<Scalars['Boolean']['output']>;
  hasTrackerChallenges?: Maybe<Scalars['Boolean']['output']>;
  hideFooterLogo?: Maybe<Scalars['Boolean']['output']>;
  hideNavigationBar?: Maybe<Scalars['Boolean']['output']>;
  hraMigrated?: Maybe<Scalars['Boolean']['output']>;
  hraPreferredName?: Maybe<Scalars['String']['output']>;
  hraPreferredNameVM?: Maybe<HraPreferredNameVm>;
  hraProviderType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  joinUrl?: Maybe<Scalars['Void']['output']>;
  loginRedirectDomain?: Maybe<Scalars['Void']['output']>;
  loginRedirectUser?: Maybe<Scalars['Void']['output']>;
  logoutAfterClosingTab?: Maybe<Scalars['Boolean']['output']>;
  manuallyEnteredAlwaysValidated?: Maybe<Scalars['Boolean']['output']>;
  maritzType?: Maybe<Scalars['String']['output']>;
  mccRewardsMethod?: Maybe<Scalars['String']['output']>;
  memberCancellationDuration?: Maybe<Scalars['Int']['output']>;
  memberDataRegion?: Maybe<Scalars['String']['output']>;
  navigateEndDate?: Maybe<Scalars['Void']['output']>;
  navigateLaunchDate?: Maybe<Scalars['Void']['output']>;
  offPlatformRedemptionEnabled?: Maybe<Scalars['Boolean']['output']>;
  onPlatformRedemptionDetails?: Maybe<Scalars['Boolean']['output']>;
  onboardingChallengeBlocker?: Maybe<Scalars['Void']['output']>;
  passportBillingMethod?: Maybe<Scalars['Void']['output']>;
  passportEndDate?: Maybe<Scalars['Void']['output']>;
  passportFastTrackDuration?: Maybe<Scalars['Void']['output']>;
  passportLaunchDate?: Maybe<Scalars['Void']['output']>;
  passwordProvider?: Maybe<Scalars['String']['output']>;
  passwordResetChallenge?: Maybe<Scalars['String']['output']>;
  phoneNumberCollectionAllowed?: Maybe<Scalars['Boolean']['output']>;
  promptForPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  redemptionProviderAccount?: Maybe<Scalars['Void']['output']>;
  redemptionProviderCustomer?: Maybe<Scalars['Void']['output']>;
  rejectExpiredSamlAssertion?: Maybe<Scalars['Boolean']['output']>;
  resetCompletedJourneys?: Maybe<Scalars['Boolean']['output']>;
  rewardsMigrated?: Maybe<Scalars['Boolean']['output']>;
  rewardsMigratedActive?: Maybe<Scalars['Boolean']['output']>;
  rewardsMigratedDate?: Maybe<Scalars['String']['output']>;
  rewardsProcessBothPlatforms?: Maybe<Scalars['Boolean']['output']>;
  rewardsRedemptionProvider?: Maybe<Scalars['String']['output']>;
  sourceCompany?: Maybe<Scalars['String']['output']>;
  sponsorStatus?: Maybe<Scalars['String']['output']>;
  spouseDetailViewEnabled?: Maybe<Scalars['Boolean']['output']>;
  ssoIdpIdentifier?: Maybe<Scalars['Void']['output']>;
  ssoRedirectUrl?: Maybe<Scalars['Void']['output']>;
  ssoSegment?: Maybe<Scalars['Void']['output']>;
  ssoSponsorAlias?: Maybe<Scalars['Void']['output']>;
  supportDepartment?: Maybe<Scalars['String']['output']>;
  supportPhoneDisabled?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  usernameOnlyLogin?: Maybe<Scalars['Boolean']['output']>;
};

export type SponsorSettingsBenefits = {
  __typename?: 'SponsorSettingsBenefits';
  enableVpNavigate: Scalars['Boolean']['output'];
  hasHub: Scalars['Boolean']['output'];
  navigateEndDate?: Maybe<Scalars['Date']['output']>;
  navigateLaunchDate?: Maybe<Scalars['Date']['output']>;
};

export type SponsorSettingsUi = {
  __typename?: 'SponsorSettingsUI';
  createdDate?: Maybe<Scalars['String']['output']>;
  disableClientAdminUI?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sponsorId?: Maybe<Scalars['Float']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type SponsorSettingsUiBenefits = {
  __typename?: 'SponsorSettingsUiBenefits';
  disableClientAdminUi: Scalars['Boolean']['output'];
  navigationLayout: Scalars['String']['output'];
};

/** A temporary object for a skeleton schema */
export type TestEndpointClaimsResult = {
  __typename?: 'TestEndpointClaimsResult';
  /** enterprisePersonId */
  enterprisePersonId?: Maybe<Scalars['String']['output']>;
  /** firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** id */
  id?: Maybe<Scalars['String']['output']>;
  /** memberId. */
  memberId?: Maybe<Scalars['String']['output']>;
  /** profileId */
  profileId?: Maybe<Scalars['String']['output']>;
};

/** A temporary object for a skeleton schema */
export type TestEndpointPcdmResult = {
  __typename?: 'TestEndpointPCDMResult';
  /** enterprisePersonId */
  enterprisePersonId?: Maybe<Scalars['String']['output']>;
  /** firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** id */
  id?: Maybe<Scalars['String']['output']>;
  /** memberId. */
  memberId?: Maybe<Scalars['String']['output']>;
  /** profileId */
  profileId?: Maybe<Scalars['String']['output']>;
};

/** Type that describes the timezone object */
export type TimezoneDescriptor = Node & {
  __typename?: 'TimezoneDescriptor';
  /** Timezone description */
  description?: Maybe<Scalars['String']['output']>;
  /** Timezone id */
  id: Scalars['ID']['output'];
  /** Timezone name */
  name: Scalars['String']['output'];
};

/** A connection to a list of items */
export type TimezoneDescriptorConnection = {
  __typename?: 'TimezoneDescriptorConnection';
  /** A list of edges */
  edges: Array<TimezoneDescriptorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection */
export type TimezoneDescriptorEdge = {
  __typename?: 'TimezoneDescriptorEdge';
  /** A Cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimezoneDescriptor;
};

export type TopPlanPaidDiagnosis = {
  __typename?: 'TopPlanPaidDiagnosis';
  /** Represents the claim id */
  claimId?: Maybe<Scalars['String']['output']>;
  /** Represents the diagnosis code */
  diagnosisCode?: Maybe<Scalars['String']['output']>;
  /** Represents the name of diagnosis */
  diagnosisName?: Maybe<Scalars['String']['output']>;
  /** The time period (such as quarterly, monthly) for which the top diagnosis would be calculated against the total plain paid amount */
  timePeriod: Scalars['String']['output'];
  /** Represents the total plan paid amount */
  totalPlanPaidAmount?: Maybe<Scalars['Float']['output']>;
};

export type TpaSponsorSettings = {
  __typename?: 'TpaSponsorSettings';
  hasTpaServices: Scalars['Boolean']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  tpaEndDate?: Maybe<Scalars['Date']['output']>;
  tpaLaunchDate?: Maybe<Scalars['Date']['output']>;
  transparencyVendor?: Maybe<Scalars['String']['output']>;
};

export type Trophy = {
  __typename?: 'Trophy';
  achievement?: Maybe<Query_Trophies_Items_Achievement>;
  catchPhrase?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  customRewardValue?: Maybe<Scalars['String']['output']>;
  earned?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  intervalType?: Maybe<Scalars['String']['output']>;
  lastEarnedDate?: Maybe<Scalars['String']['output']>;
  mobileUrl?: Maybe<Scalars['URL']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderIndex?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  rewardValue?: Maybe<Scalars['Int']['output']>;
  rewardableActionName?: Maybe<Scalars['String']['output']>;
  rewardableActionType?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Maybe<Query_Trophies_Items_Rewards_Items>>>;
  secondaryThreshold?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
  timesEarned?: Maybe<Scalars['Int']['output']>;
  timesRewardable?: Maybe<Scalars['Int']['output']>;
  totalEventcode?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

/** Types of unit measurements */
export enum UnitOfMeasurement {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC',
  UkImperial = 'UK_IMPERIAL'
}

/** Type that describes the unit of measurement object */
export type UnitOfMeasurementDescriptor = Node & {
  __typename?: 'UnitOfMeasurementDescriptor';
  /** Unit of measurement description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement name */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items */
export type UnitOfMeasurementDescriptorConnection = {
  __typename?: 'UnitOfMeasurementDescriptorConnection';
  /** A list of edges */
  edges: Array<UnitOfMeasurementDescriptorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection */
export type UnitOfMeasurementDescriptorEdge = {
  __typename?: 'UnitOfMeasurementDescriptorEdge';
  /** A Cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UnitOfMeasurementDescriptor;
};

/** Return type indicating error state where sponsor configuration is not supported */
export type UnsupportedConfiguration = {
  __typename?: 'UnsupportedConfiguration';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Input for creating or updating activity data */
export type UpdateActivityInput = {
  clientMutationId: Scalars['String']['input'];
  measurements: Array<ActivityMeasurement>;
  provider: ActivityProvider;
  vendor: ActivityVendor;
};

/** Input for creating or updating metrics */
export type UpdateMetricInput = {
  /** The category of workout being sent */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Client created identifier for this event. Must be unique per mutation. */
  clientMutationId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  /** The end time of the event represented in UTC. E.g.: 1996-12-19T16:39:57Z */
  endTime: Scalars['DateTime']['input'];
  metrics: Array<Metric>;
  /** The source of the UTC offset */
  offsetOrigin: Scalars['String']['input'];
  source: MetricSource;
  /** The start time of the event represented in UTC. E.g.: 1996-12-19T16:39:57Z */
  startTime: Scalars['DateTime']['input'];
  /** The type of metric update */
  type: Scalars['String']['input'];
  /** The offset in seconds from UTC */
  utcOffset: Scalars['Long']['input'];
  /** Where the client got this data from. */
  vendor: Scalars['String']['input'];
};

/** Type that describes the profile object */
export type UpdateProfileInput = {
  /** Member bio */
  bio?: InputMaybe<Scalars['String']['input']>;
  /** Member country id */
  countryId?: InputMaybe<Scalars['Int']['input']>;
  /** Member date of birth */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Member display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Member email address */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Member first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Member gender identity */
  genderIdentity?: InputMaybe<GenderIdentity>;
  /** Home phone number */
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Member language code */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Member last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile phone number */
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Member picture url */
  picture?: InputMaybe<Scalars['String']['input']>;
  /** Member timezone name */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Member unit of measurement */
  unitOfMeasurement?: InputMaybe<UnitOfMeasurement>;
};

export type UpdateProfileResponse = Profile | ValidationResult;

/** Input for creating or updating sleep data */
export type UpdateSleepInput = {
  clientMutationId: Scalars['String']['input'];
  measurements: Array<SleepMeasurement>;
  provider: ActivityProvider;
  vendor: ActivityVendor;
};

/** Validation result */
export type ValidationResult = {
  __typename?: 'ValidationResult';
  /** An error code */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** An error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** A list of field errors */
  errors: Array<FieldError>;
};

export type Query_Trophies_Items_Achievement = {
  __typename?: 'query_trophies_items_achievement';
  imageUrl?: Maybe<Scalars['URL']['output']>;
  unearnedImageUrl?: Maybe<Scalars['URL']['output']>;
  unitsLabel?: Maybe<Scalars['String']['output']>;
};

export type Query_Trophies_Items_Rewards_Items = {
  __typename?: 'query_trophies_items_rewards_items';
  rewardTypeDisplay?: Maybe<Scalars['String']['output']>;
  valueDisplay?: Maybe<Scalars['String']['output']>;
};

export type BenefitPagesSponsorSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type BenefitPagesSponsorSettingsQuery = { __typename?: 'Query', benefitPagesSponsorSettings?: { __typename?: 'BenefitPagesSponsorSettings', isNavigateExperience: boolean, isTpaEnabled: boolean, benefitsSponsorSetting: { __typename?: 'BenefitSponsorSetting', shouldOverwriteBenefitsText: boolean, shouldDisplayRecommended: boolean }, benefitsPagesSetting?: { __typename?: 'BenefitsPagesSetting', benefitsPage?: { __typename?: 'BenefitsPageLayout', pageTitle: string } | null, programsPage?: { __typename?: 'BenefitsPageLayout', pageTitle: string } | null } | null, sponsorSettingsUi: { __typename?: 'SponsorSettingsUiBenefits', navigationLayout: string } } | null };

export type InsurancePlanAccumulatorsQueryVariables = Exact<{
  planType?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsurancePlanAccumulatorsQuery = { __typename?: 'Query', insurancePlanAccumulators?: { __typename?: 'InsurancePlanAccumulators', planId: number, planLevel: string, lastUpdate: any, accumulatorData: Array<{ __typename?: 'InsurancePlanAccumulatorsCoverage', applied?: string | null, coverage: string, level: string, limit?: string | null, network: string, progress: number, remaining?: string | null, accumulatorName?: string | null } | null> } | null };

export type InsurancePlanByTypeQueryVariables = Exact<{
  planType?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsurancePlanByTypeQuery = { __typename?: 'Query', insurancePlan?: { __typename?: 'InsurancePlan', id?: number | null, name?: string | null, imageUrl?: string | null, longDescription?: string | null, shortDescription?: string | null, phoneNumber?: string | null, websiteUrl?: string | null, type?: InsurancePlanType | null, subscriber?: { __typename?: 'InsurancePlanMember', active?: boolean | null, dateOfBirth?: any | null, effectiveEndDate?: any | null, effectiveStartDate?: any | null, enterprisePersonId?: string | null, firstName?: string | null, lastName?: string | null, primarySubscriber?: boolean | null, subscriberId?: string | null, consent?: string | null, groupId?: string | null } | null, attachments?: Array<{ __typename?: 'InsurancePlanAttachment', format?: string | null, linkUrl?: string | null, sortOrder?: number | null, title?: string | null, type?: string | null } | null> | null, coverage?: { __typename?: 'InsurancePlanCoverage', showAccumulators: string, type: string, amounts: Array<{ __typename?: 'InsurancePlanCoverageAmount', id: number, amount?: number | null, network: string, planLevel: string, coverage: string, customLabel?: string | null } | null> } | null } | null, insurancePlanMembers?: { __typename?: 'InsurancePlanMemberConnection', data?: Array<{ __typename?: 'InsurancePlanMember', firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, effectiveEndDate?: any | null, effectiveStartDate?: any | null, primarySubscriber?: boolean | null, enterprisePersonId?: string | null, active?: boolean | null, imageUrl?: string | null, subscriberId?: string | null } | null> | null } | null };

export type InsurancePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type InsurancePlansQuery = { __typename?: 'Query', insurancePlans?: { __typename?: 'InsurancePlanConnection', data?: Array<{ __typename?: 'InsurancePlan', id?: number | null, name?: string | null, imageUrl?: string | null, longDescription?: string | null, shortDescription?: string | null, phoneNumber?: string | null, websiteUrl?: string | null, type?: InsurancePlanType | null, subscriber?: { __typename?: 'InsurancePlanMember', active?: boolean | null, dateOfBirth?: any | null, effectiveEndDate?: any | null, effectiveStartDate?: any | null, enterprisePersonId?: string | null, firstName?: string | null, lastName?: string | null, primarySubscriber?: boolean | null, subscriberId?: string | null, consent?: string | null, groupId?: string | null } | null, attachments?: Array<{ __typename?: 'InsurancePlanAttachment', format?: string | null, linkUrl?: string | null, sortOrder?: number | null, title?: string | null, type?: string | null } | null> | null, coverage?: { __typename?: 'InsurancePlanCoverage', type: string, showAccumulators: string, amounts: Array<{ __typename?: 'InsurancePlanCoverageAmount', id: number, planLevel: string, network: string, coverage: string, amount?: number | null } | null> } | null } | null> | null } | null };

export type MemberBenefitsFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberBenefitsFeaturesQuery = { __typename?: 'Query', memberBenefitsFeatures?: { __typename?: 'MemberBenefitsFeatures', findCareFeatures: { __typename?: 'FindCareFeatures', hasFindCare?: boolean | null, hasFindCareOnlineDoctor?: boolean | null }, insurancePlanFeatures: { __typename?: 'InsurancePlanFeatures', hasIdCards: boolean, hasInsuranceClaims: boolean, hasMedicalInsurancePlan: boolean } } | null };

export type HomepageBenefitPagesSponsorSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageBenefitPagesSponsorSettingsQuery = { __typename?: 'Query', benefitPagesSponsorSettings?: { __typename?: 'BenefitPagesSponsorSettings', isNavigateExperience: boolean, benefitsSponsorSetting: { __typename?: 'BenefitSponsorSetting', shouldOverwriteBenefitsText: boolean }, sponsorSettingsUi: { __typename?: 'SponsorSettingsUiBenefits', navigationLayout: string } } | null };

export type HomepageMemberRecommendationsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageMemberRecommendationsQuery = { __typename?: 'Query', habits?: Array<{ __typename?: 'Recommendation', id: string, title?: string | null, description?: string | null, recommendationType?: RecommendationType | null, imageUrl?: string | null } | null> | null, journeys?: Array<{ __typename?: 'Recommendation', id: string, title?: string | null, description?: string | null, recommendationType?: RecommendationType | null, imageUrl?: string | null } | null> | null, media?: Array<{ __typename?: 'Recommendation', id: string, title?: string | null, description?: string | null, recommendationType?: RecommendationType | null, imageUrl?: string | null } | null> | null, habitChallenges?: Array<{ __typename?: 'Recommendation', id: string, title?: string | null, description?: string | null, recommendationType?: RecommendationType | null, imageUrl?: string | null } | null> | null, benefitPrograms?: Array<{ __typename?: 'Recommendation', id: string, title?: string | null, description?: string | null, recommendationType?: RecommendationType | null, imageUrl?: string | null } | null> | null, interests?: Array<{ __typename?: 'Recommendation', id: string, title?: string | null, description?: string | null, recommendationType?: RecommendationType | null, imageUrl?: string | null } | null> | null };

export type GendersQueryQueryVariables = Exact<{
  withNonBinary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GendersQueryQuery = { __typename?: 'Query', genders: { __typename?: 'GenderIdentityDescriptorConnection', edges: Array<{ __typename?: 'GenderIdentityDescriptorEdge', node: { __typename?: 'GenderIdentityDescriptor', id: string, description?: string | null } }> } };

export type InsuranceClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type InsuranceClaimsQuery = { __typename?: 'Query', insuranceClaims?: { __typename?: 'ClaimConnection', edges?: Array<{ __typename?: 'ClaimEdge', node?: { __typename?: 'Claim', id: string, claimNumber: string, patientFirstName: string, patientLastName: string, patientResponsibilityAmount?: number | null, totalChargedAmount?: number | null, serviceStartDate?: any | null, provider?: { __typename?: 'ClaimProvider', name?: string | null } | null } | null } | null> | null } | null };

export type InsurancePlanAccumulatorsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type InsurancePlanAccumulatorsDataQuery = { __typename?: 'Query', insurancePlanAccumulators?: { __typename?: 'InsurancePlanAccumulators', planId: number, planLevel: string, lastUpdate: any, accumulatorData: Array<{ __typename?: 'InsurancePlanAccumulatorsCoverage', level: string, coverage: string, applied?: string | null, remaining?: string | null, limit?: string | null, progress: number, network: string } | null> } | null };

export type MedicalInsurancePlanQueryVariables = Exact<{ [key: string]: never; }>;


export type MedicalInsurancePlanQuery = { __typename?: 'Query', insurancePlan?: { __typename?: 'InsurancePlan', name?: string | null, subscriber?: { __typename?: 'InsurancePlanMember', effectiveStartDate?: any | null, subscriberId?: string | null, groupId?: string | null } | null, coverage?: { __typename?: 'InsurancePlanCoverage', showAccumulators: string, type: string, amounts: Array<{ __typename?: 'InsurancePlanCoverageAmount', id: number, planLevel: string, network: string, coverage: string, customLabel?: string | null, amount?: number | null } | null> } | null } | null };

export type ProfileQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQueryQuery = { __typename?: 'Query', isExternallySyncedMember: boolean, profile?: { __typename?: 'Profile', id: string, memberId: string, personId: string, sponsorId?: string | null, externalId?: string | null, enterprisePersonId?: string | null, unitOfMeasurement?: UnitOfMeasurement | null, genderIdentity?: GenderIdentity | null, emailAddress?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, dateOfBirth?: any | null, enrollmentDate?: any | null, picture?: string | null, bio?: string | null, language?: { __typename?: 'LanguageDescriptor', id: string, code?: string | null, description?: string | null } | null, timezone?: { __typename?: 'TimezoneDescriptor', id: string, name: string, description?: string | null } | null, country?: { __typename?: 'Country', id: string, name: string, phoneCode?: string | null, code?: string | null } | null, phoneSettings?: { __typename?: 'PhoneSettings', mobileNumber?: string | null, mobileNumberVerified?: boolean | null, mobileNumberIsoCode?: string | null, homeNumber?: string | null, homeNumberIsoCode?: string | null } | null } | null };

export type StaticDataQueryQueryVariables = Exact<{
  withNonBinary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StaticDataQueryQuery = { __typename?: 'Query', countries: { __typename?: 'CountryConnection', edges: Array<{ __typename?: 'CountryEdge', node: { __typename?: 'Country', id: string, code?: string | null, name: string, cookiePolicy: boolean, storeUrl?: string | null, phoneCode?: string | null } }> }, languages: { __typename?: 'LanguageDescriptorConnection', edges: Array<{ __typename?: 'LanguageDescriptorEdge', node: { __typename?: 'LanguageDescriptor', id: string, code?: string | null, description?: string | null, englishNative?: string | null, selectable?: boolean | null } }> }, timezones: { __typename?: 'TimezoneDescriptorConnection', edges: Array<{ __typename?: 'TimezoneDescriptorEdge', node: { __typename?: 'TimezoneDescriptor', id: string, name: string, description?: string | null } }> }, unitOfMeasurements: { __typename?: 'UnitOfMeasurementDescriptorConnection', edges: Array<{ __typename?: 'UnitOfMeasurementDescriptorEdge', node: { __typename?: 'UnitOfMeasurementDescriptor', id: string, description?: string | null } }> }, genders: { __typename?: 'GenderIdentityDescriptorConnection', edges: Array<{ __typename?: 'GenderIdentityDescriptorEdge', node: { __typename?: 'GenderIdentityDescriptor', id: string, description?: string | null, genderCode?: string | null, binary?: boolean | null } }> } };

export type UpdateProfileMutationVariables = Exact<{
  input?: InputMaybe<UpdateProfileInput>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename: 'Profile', id: string, memberId: string, personId: string, sponsorId?: string | null, externalId?: string | null, enterprisePersonId?: string | null, unitOfMeasurement?: UnitOfMeasurement | null, genderIdentity?: GenderIdentity | null, emailAddress?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, dateOfBirth?: any | null, enrollmentDate?: any | null, picture?: string | null, bio?: string | null, language?: { __typename?: 'LanguageDescriptor', id: string, code?: string | null, description?: string | null } | null, timezone?: { __typename?: 'TimezoneDescriptor', id: string, name: string, description?: string | null } | null, country?: { __typename?: 'Country', id: string, name: string, phoneCode?: string | null, code?: string | null } | null, phoneSettings?: { __typename?: 'PhoneSettings', mobileNumber?: string | null, mobileNumberVerified?: boolean | null, mobileNumberIsoCode?: string | null, homeNumber?: string | null, homeNumberIsoCode?: string | null } | null } | { __typename: 'ValidationResult', errorMessage?: string | null, errors: Array<{ __typename?: 'FieldError', field?: string | null, errorCode?: string | null, errorMessage?: string | null }> } | null };

export const BenefitPagesSponsorSettingsDocument = gql`
    query BenefitPagesSponsorSettings {
  benefitPagesSponsorSettings {
    benefitsSponsorSetting {
      shouldOverwriteBenefitsText
      shouldDisplayRecommended
    }
    benefitsPagesSetting {
      benefitsPage {
        pageTitle
      }
      programsPage {
        pageTitle
      }
    }
    sponsorSettingsUi {
      navigationLayout
    }
    isNavigateExperience
    isTpaEnabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BenefitPagesSponsorSettingsGQL extends Apollo.Query<BenefitPagesSponsorSettingsQuery, BenefitPagesSponsorSettingsQueryVariables> {
    document = BenefitPagesSponsorSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsurancePlanAccumulatorsDocument = gql`
    query InsurancePlanAccumulators($planType: String) {
  insurancePlanAccumulators(planType: $planType) {
    planId
    planLevel
    lastUpdate
    accumulatorData {
      applied
      coverage
      level
      limit
      network
      progress
      remaining
      accumulatorName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsurancePlanAccumulatorsGQL extends Apollo.Query<InsurancePlanAccumulatorsQuery, InsurancePlanAccumulatorsQueryVariables> {
    document = InsurancePlanAccumulatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsurancePlanByTypeDocument = gql`
    query insurancePlanByType($planType: String) {
  insurancePlan(planType: $planType) {
    id
    name
    imageUrl
    longDescription
    shortDescription
    phoneNumber
    websiteUrl
    type
    subscriber {
      active
      dateOfBirth
      effectiveEndDate
      effectiveStartDate
      enterprisePersonId
      firstName
      lastName
      primarySubscriber
      subscriberId
      consent
      groupId
    }
    attachments {
      format
      linkUrl
      sortOrder
      title
      type
    }
    coverage {
      amounts {
        id
        amount
        network
        planLevel
        coverage
        customLabel
      }
      showAccumulators
      type
    }
  }
  insurancePlanMembers(planType: $planType) {
    data {
      firstName
      lastName
      dateOfBirth
      effectiveEndDate
      effectiveStartDate
      primarySubscriber
      enterprisePersonId
      active
      imageUrl
      subscriberId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsurancePlanByTypeGQL extends Apollo.Query<InsurancePlanByTypeQuery, InsurancePlanByTypeQueryVariables> {
    document = InsurancePlanByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsurancePlansDocument = gql`
    query InsurancePlans {
  insurancePlans {
    data {
      id
      name
      imageUrl
      longDescription
      shortDescription
      phoneNumber
      websiteUrl
      type
      subscriber {
        active
        dateOfBirth
        effectiveEndDate
        effectiveStartDate
        enterprisePersonId
        firstName
        lastName
        primarySubscriber
        subscriberId
        consent
        groupId
      }
      attachments {
        format
        linkUrl
        sortOrder
        title
        type
      }
      coverage {
        amounts {
          id
          planLevel
          network
          coverage
          amount
        }
        type
        showAccumulators
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsurancePlansGQL extends Apollo.Query<InsurancePlansQuery, InsurancePlansQueryVariables> {
    document = InsurancePlansDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MemberBenefitsFeaturesDocument = gql`
    query memberBenefitsFeatures {
  memberBenefitsFeatures {
    findCareFeatures {
      hasFindCare
      hasFindCareOnlineDoctor
    }
    insurancePlanFeatures {
      hasIdCards
      hasInsuranceClaims
      hasMedicalInsurancePlan
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MemberBenefitsFeaturesGQL extends Apollo.Query<MemberBenefitsFeaturesQuery, MemberBenefitsFeaturesQueryVariables> {
    document = MemberBenefitsFeaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HomepageBenefitPagesSponsorSettingsDocument = gql`
    query HomepageBenefitPagesSponsorSettings {
  benefitPagesSponsorSettings {
    benefitsSponsorSetting {
      shouldOverwriteBenefitsText
    }
    sponsorSettingsUi {
      navigationLayout
    }
    isNavigateExperience
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HomepageBenefitPagesSponsorSettingsGQL extends Apollo.Query<HomepageBenefitPagesSponsorSettingsQuery, HomepageBenefitPagesSponsorSettingsQueryVariables> {
    document = HomepageBenefitPagesSponsorSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HomepageMemberRecommendationsDocument = gql`
    query HomepageMemberRecommendations {
  habits: recommendations(
    input: {source: NBHA, recommendationType: Habits, recommendationCount: 2}
  ) {
    id
    title
    description
    recommendationType
    imageUrl
  }
  journeys: recommendations(
    input: {source: NBHA, recommendationType: Journeys, recommendationCount: 1}
  ) {
    id
    title
    description
    recommendationType
    imageUrl
  }
  media: recommendations(
    input: {source: NBHA, recommendationType: Media, recommendationCount: 1}
  ) {
    id
    title
    description
    recommendationType
    imageUrl
  }
  habitChallenges: recommendations(
    input: {source: NBHA, recommendationType: HabitChallenges, recommendationCount: 1}
  ) {
    id
    title
    description
    recommendationType
    imageUrl
  }
  benefitPrograms: recommendations(
    input: {source: NBHA, recommendationType: BenefitPrograms, recommendationCount: 2}
  ) {
    id
    title
    description
    recommendationType
    imageUrl
  }
  interests: recommendations(
    input: {source: NBHA, recommendationType: Interests, recommendationCount: 1}
  ) {
    id
    title
    description
    recommendationType
    imageUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HomepageMemberRecommendationsGQL extends Apollo.Query<HomepageMemberRecommendationsQuery, HomepageMemberRecommendationsQueryVariables> {
    document = HomepageMemberRecommendationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GendersQueryDocument = gql`
    query GendersQuery($withNonBinary: Boolean = false) {
  genders(withNonBinary: $withNonBinary) {
    edges {
      node {
        id
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GendersQueryGQL extends Apollo.Query<GendersQueryQuery, GendersQueryQueryVariables> {
    document = GendersQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsuranceClaimsDocument = gql`
    query insuranceClaims {
  insuranceClaims(first: 2) {
    edges {
      node {
        id
        claimNumber
        patientFirstName
        patientLastName
        patientResponsibilityAmount
        totalChargedAmount
        provider {
          name
        }
        serviceStartDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsuranceClaimsGQL extends Apollo.Query<InsuranceClaimsQuery, InsuranceClaimsQueryVariables> {
    document = InsuranceClaimsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsurancePlanAccumulatorsDataDocument = gql`
    query InsurancePlanAccumulatorsData {
  insurancePlanAccumulators(planType: "Medical") {
    planId
    planLevel
    lastUpdate
    accumulatorData {
      level
      coverage
      applied
      remaining
      limit
      progress
      network
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsurancePlanAccumulatorsDataGQL extends Apollo.Query<InsurancePlanAccumulatorsDataQuery, InsurancePlanAccumulatorsDataQueryVariables> {
    document = InsurancePlanAccumulatorsDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MedicalInsurancePlanDocument = gql`
    query MedicalInsurancePlan {
  insurancePlan(planType: "Medical") {
    name
    subscriber {
      effectiveStartDate
      subscriberId
      groupId
    }
    coverage {
      showAccumulators
      amounts {
        id
        planLevel
        network
        coverage
        customLabel
        amount
      }
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MedicalInsurancePlanGQL extends Apollo.Query<MedicalInsurancePlanQuery, MedicalInsurancePlanQueryVariables> {
    document = MedicalInsurancePlanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfileQueryDocument = gql`
    query ProfileQuery {
  profile {
    id
    memberId
    personId
    sponsorId
    externalId
    enterprisePersonId
    unitOfMeasurement
    genderIdentity
    emailAddress
    username
    firstName
    lastName
    displayName
    dateOfBirth
    enrollmentDate
    picture
    bio
    language {
      id
      code
      description
    }
    timezone {
      id
      name
      description
    }
    country {
      id
      name
      phoneCode
      code
    }
    phoneSettings {
      mobileNumber
      mobileNumberVerified
      mobileNumberIsoCode
      homeNumber
      homeNumberIsoCode
    }
  }
  isExternallySyncedMember
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfileQueryGQL extends Apollo.Query<ProfileQueryQuery, ProfileQueryQueryVariables> {
    document = ProfileQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StaticDataQueryDocument = gql`
    query StaticDataQuery($withNonBinary: Boolean = false) {
  countries {
    edges {
      node {
        id
        code
        name
        cookiePolicy
        storeUrl
        phoneCode
      }
    }
  }
  languages {
    edges {
      node {
        id
        code
        description
        englishNative
        selectable
      }
    }
  }
  timezones {
    edges {
      node {
        id
        name
        description
      }
    }
  }
  unitOfMeasurements {
    edges {
      node {
        id
        description
      }
    }
  }
  genders(withNonBinary: $withNonBinary) {
    edges {
      node {
        id
        description
        genderCode
        binary
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StaticDataQueryGQL extends Apollo.Query<StaticDataQueryQuery, StaticDataQueryQueryVariables> {
    document = StaticDataQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput) {
  updateProfile(input: $input) {
    ... on ValidationResult {
      __typename
      errorMessage
      errors {
        field
        errorCode
        errorMessage
      }
    }
    ... on Profile {
      __typename
      id
      memberId
      personId
      sponsorId
      externalId
      enterprisePersonId
      unitOfMeasurement
      genderIdentity
      emailAddress
      username
      firstName
      lastName
      displayName
      dateOfBirth
      enrollmentDate
      picture
      bio
      language {
        id
        code
        description
      }
      timezone {
        id
        name
        description
      }
      country {
        id
        name
        phoneCode
        code
      }
      phoneSettings {
        mobileNumber
        mobileNumberVerified
        mobileNumberIsoCode
        homeNumber
        homeNumberIsoCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfileGQL extends Apollo.Mutation<UpdateProfileMutation, UpdateProfileMutationVariables> {
    document = UpdateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }